import { render, staticRenderFns } from "./jettyForm.vue?vue&type=template&id=0521c960&scoped=true&"
import script from "./jettyForm.vue?vue&type=script&lang=js&"
export * from "./jettyForm.vue?vue&type=script&lang=js&"
import style0 from "./jettyForm.vue?vue&type=style&index=0&id=0521c960&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0521c960",
  null
  
)

export default component.exports